import { createFileRoute, redirect } from '@tanstack/react-router';
import { FormattedMessage } from 'react-intl';

import { preLoadDefaultProject } from '@/lib/queries/project';
import { slackAuth } from '@/lib/queries/slackAuth';
import { supabaseClient } from '@/lib/supabase';

export const Route = createFileRoute('/authorize/slack/$userId/')({
  loader: async ({ context, params: { userId } }) => {
    const {
      data: { session },
    } = await supabaseClient.auth.getSession();

    if (!session) {
      throw redirect({
        to: '/sign-in',
        search: {
          source: 'slack',
          userId,
        },
      });
    }
    try {
      const defaultProject = await preLoadDefaultProject({ context });
      await slackAuth(defaultProject.id, userId);

      return {
        message: 'Your Slack integration has been successfully linked!',
      };
    } catch (e) {
      console.error(e);
      context.toast({
        title: 'configuration.mcpJwt.button.error',
        variant: 'destructive',
      });
      throw redirect({ to: '/' });
    }
  },
  component: LinkedSlackIntegrationPage,
});

function LinkedSlackIntegrationPage() {
  return (
    <main className="flex items-center justify-center min-h-screen bg-inherit">
      <div className="w-full max-w-md p-6 bg-inherit shadow-lg rounded-md">
        <h1 className="text-xl font-semibold text-inherit mb-4">
          <FormattedMessage id="slackIntegration.successMessage" />
        </h1>
        <p className="text-sm text-inherit mb-6">
          <FormattedMessage id="slackIntegration.closePrompt" />
        </p>
      </div>
    </main>
  );
}
